function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import css from './Anchor.sass';
/* Helpers */

var getElement = function getElement(as, pseudo, to) {
  if (as) return as;
  return pseudo ? 'div' : to ? Link : 'a';
};

var Anchor = function Anchor(props) {
  var as = props.as,
      to = props.to,
      href = props.href,
      wrapper = props.wrapper,
      className = props.className,
      children = props.children,
      content = props.content,
      pseudo = props.pseudo,
      grey = props.grey,
      underline = props.underline,
      rest = _objectWithoutProperties(props, ["as", "to", "href", "wrapper", "className", "children", "content", "pseudo", "grey", "underline"]);

  var classNames = cx(css.root, wrapper && css.wrapper, pseudo && css.pseudo, grey && css.grey, underline && css.underline, className);
  var Element = getElement(as, pseudo, to);
  return React.createElement(Element, _extends({
    to: to,
    href: href,
    className: classNames
  }, rest), children || content);
};

Anchor.displayName = 'Anchor';
var string = PropTypes.string,
    bool = PropTypes.bool,
    node = PropTypes.node;
Anchor.propTypes = {
  /**
   * Custom CSS class name
   */
  as: node,

  /**
   * Custom CSS class name
   */
  className: string,

  /**
   * React router link to
   */
  to: string,

  /**
   *  Link href
   */
  href: string,

  /**
   * Is display inline
   * */
  wrapper: bool,

  /**
   * Pseudo link has dashed bottom border
   * */
  pseudo: bool,

  /**
   * Grey theme mostly for pseudo links
   * */
  grey: bool,

  /**
   * If link should be underlined
   * */
  underline: bool,

  /**
   * Primary content
   */
  children: node,

  /**
   * Primary content
   */
  content: string
};
Anchor.defaultProps = {};
export { Anchor };